import { render, staticRenderFns } from "./observa4ResultTable.vue?vue&type=template&id=727143f3&scoped=true"
import script from "./observa4ResultTable.vue?vue&type=script&lang=js"
export * from "./observa4ResultTable.vue?vue&type=script&lang=js"
import style0 from "./observa4ResultTable.vue?vue&type=style&index=0&id=727143f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727143f3",
  null
  
)

export default component.exports